import { articles, heroSlides, type Article } from '@/mocks/articles';

export const getArticleById = (id: string): Article | undefined =>
  articles.find((item) => item.id === id);

export const getArticlesByCategory = (category: string): Article[] =>
  articles.filter((item) => item.category === category);

export const sortByTime = (list: Article[]): Article[] =>
  [...list].sort(
    (a, b) => new Date(b.publishTime).getTime() - new Date(a.publishTime).getTime(),
  );

export const sortByHot = (list: Article[]): Article[] =>
  [...list].sort((a, b) => b.views + b.shares * 3 - (a.views + a.shares * 3));

export const getLatest = (limit = 6): Article[] => sortByTime(articles).slice(0, limit);

export const getHot = (limit = 6): Article[] => sortByHot(articles).slice(0, limit);

export const getFeaturedArticles = (): Article[] =>
  heroSlides
    .map((slide) => ({
      article: getArticleById(slide.id),
      image: slide.image,
    }))
    .filter(
      (item): item is { article: Article; image: string } => Boolean(item.article),
    );

export const getRelated = (article: Article, limit = 4): Article[] => {
  const sameCategory = articles.filter(
    (item) => item.category === article.category && item.id !== article.id,
  );
  const scored = sameCategory
    .map((item) => {
      const sharedTags = item.tags.filter((tag) => article.tags.includes(tag)).length;
      return { item, score: sharedTags };
    })
    .sort((a, b) => b.score - a.score || b.item.views - a.item.views);
  return scored.slice(0, limit).map((entry) => entry.item);
};

export const searchArticles = (keyword: string): Article[] => {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return articles.filter((item) => {
    const haystack = `${item.title} ${item.summary} ${item.tags.join(' ')}`.toLowerCase();
    return haystack.includes(q);
  });
};

export const hotSearchTerms = [
  '长风渡月',
  '林知夏',
  '金映奖',
  '短剧',
  '程野巡演',
  'AI换脸',
  '演唱会实名制',
  '回忆杀',
];

export const formatDate = (iso: string): string => {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
};

export const formatDateShort = (iso: string): string => {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getMonth() + 1}月${d.getDate()}日 ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const formatViews = (views: number): string => {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return String(views);
};